import React, { FC } from 'react';
import { SpriteImage } from '../../SpriteImage/SpriteImage';

import styles from './headermenu.module.scss';

const { subMenuTitle, subMenuSubTitle, chevronUp, chevronRight } = styles;

interface ISubMenuProps {
    onClick: () => void;
    toggled: boolean;
    title: string;
    subTitle: string;
}

export const SubMenu: FC<ISubMenuProps> = ({ children, onClick, subTitle, title, toggled }) => {
    const chevronType = toggled ? chevronUp : chevronRight;

    return (
        <>
            <button
                onClick={onClick}
                aria-haspopup="menu"
                aria-expanded={toggled}
                aria-label={`${title}. ${subTitle}`}
                className="w-100 d-flex flex-row align-items-center justify-content-between"
            >
                <div className="d-flex flex-column align-items-start justify-content-center">
                    <span className={subMenuTitle}>{title}</span>
                    <span className={subMenuSubTitle}>{subTitle}</span>
                </div>

                <SpriteImage className={chevronType} />
            </button>

            {!toggled ? null : children}
        </>
    );
};
